<template>
  <div>
    <v-container fluid class="d-flex justify-space-between align-center">
      <div class="report_section">
        <h1 class="title_page">Reports</h1>
        <v-btn color="primary" class="export-btn" @click="exportReports">
          <v-icon class="mr-2">mdi-download</v-icon>
          Export
        </v-btn>
        <v-btn color="primary" class="export-btn" @click="showGraph">
          <v-icon class="mr-2">mdi-finance</v-icon>
            {{ isGraphVisible ? "Hide Graph" : "Show Graph" }}
        </v-btn>
      </div>
      <div class="d-flex justify-space-between align-center">
        <v-btn color="primary" class="export-btn" @click="manageSettings">
          <v-icon class="mr-2">mdi-cog</v-icon>
          Settings
        </v-btn>
      </div>
    </v-container>
    <ReportTabV2
            v-if="!loading"
            name="name"
            :params="{}"
            :additionalColumns="[]"
            :isShowBlacklisted="isShowBlacklisted"
    />
    <ExportSettings
        :isShow="isExportSettingsDialogOpen"
        :headers="currentFields"
        :example="{}"
    >
    </ExportSettings>
    <ProfileSettings :isShow="isShowSettings"/>
  </div>
</template>

<script>
import MainLayout from "../../layouts/MainLayout"
import ReportTabV2 from "./tabsReports/ReportTabV2"
import ExportSettings from "./modals/ExportSettings";
import ProfileSettings from "./modals/ProfileSettings";
import {mapState, mapGetters} from "vuex";
import store from "@/store";

export default {
  components: {
    ReportTabV2,
    ExportSettings,
    ProfileSettings
  },
  data() {
    return {
      isGraphVisible: false,
      loading: true,
      activeTab: 0,
      isShowSettings: false,
      isExportSettingsDialogOpen: false,
      currentFields: [],
      commonHeaders: [
        'uvs',
        'clicks',
        'registrations',
        'installations',
        'sales',
        'reg_tp',
        'conversions',
        'total_paid',
        'epc',
        'avg_cost',
        'cost',
        'revenue',
        'margin',
        'profit',
        'sales_ratio',
        'uvs_sales_ratio'
      ],
      initialTabs: [],
      tabs: [
        {
          name: 'Offers',
          params: {key: 'offers', name: 'Offer', value: 'offer', type: 'offer_id', entity: 'offer_id', breadCrumbs: [], id: 'offers'},
          additionalColumns: [{text: 'Advertiser', value: 'advertiser', sortKey: 'advertiser_id'}]
        },
        {
          name: 'Campaigns',
          params: {key: 'campaign', name: 'Campaign', value: 'campaign', type: 'campaign_id', entity: 'campaign_id', breadCrumbs: [], id: 'campaign'},
          additionalColumns: [{text: 'Affiliate', value: 'affiliate', sortKey: 'affiliate_id'}]
        },
        {
          name: 'Affiliates',
          params: {key: 'affiliate', name: 'Affiliate', value: 'affiliate', type: 'affiliate_id', entity: 'affiliate_id', breadCrumbs: [], id: 'affiliate'},
          additionalColumns: [{text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'}]
        },
        {
          name: 'Programs',
          params: {key: 'program', name: 'Program', value: 'program', type: 'program_id', entity: 'program_id', breadCrumbs: [], id: 'program'},
        },
        {
          name: 'Advertisers',
          params: {key: 'advertiser', name: 'Advertiser', value: 'advertiser', type: 'advertiser_id', entity: 'advertiser_id', breadCrumbs: [], id: 'advertiser'}
        },
        {
          name: 'AM',
          params: {key: 'affiliate_manager', name: 'AM', value: 'affiliate_manager', type: 'affiliate_manager_id', entity: 'affiliate_manager_id', breadCrumbs: [], id: 'affiliate_manager'}
        },
        {
          name: 'BD',
          params: {key: 'advertiser_manager', name: 'BD', value: 'advertiser_manager', type: 'advertiser_manager_id', entity: 'advertiser_manager_id', breadCrumbs: [], id: 'advertiser_manager'}
        },
        {
          name: 'Geo',
          params: {key: 'geo', value: 'geo', name: 'GEO', type: 'geo', entity: 'geo', breadCrumbs: [], id: 'geo'}
        },
        {
          name: 'Hour',
          params: {key: 'hour', value: 'hour', name: 'Hour', type: 'hour', entity: 'hour', breadCrumbs: [], id: 'hour'}
        },
        {
          name: 'Device',
          params: {key: 'device', value: 'device', name: 'Device', type: 'device', entity: 'device', breadCrumbs: [], id: 'device'}
        },
        {
          name: 'Verticals',
          params: {key: 'vertical_name', value: 'vertical_name', name: 'vertical_name', type: 'vertical_name', entity: 'vertical_name', breadCrumbs: [], id: 'vertical_name'}
        },
        // {
        //   name: 'Image',
        //   params: {key: 'img', value: 'img', name: 'img', type: 'img', entity: 'img', breadCrumbs: [], id: 'img'}
        // },
        // {
        //   name: 'Keyword',
        //   params: {key: 'kw', value: 'kw', name: 'kw', type: 'kw', entity: 'kw', breadCrumbs: [], id: 'kw'}
        // }
      ],
      onlyAggregatedStats: true,
      isShowBlacklisted: false,
    }
  },
  async mounted() {
    this.initialTabs = [...this.tabs];
    this.loadSettings();

    document.title = `Reports-${this.$route.params.type?this.$route.params.type:'Offers'}`;
    this.setCurrentFields();
    if (this.user[0].can('reports_both_POV')
        || this.user[0].can('reports_affiliates_POV')
    ) {
      this.onlyAggregatedStats = true
    }
    if(!this.$route.params.type) {
      this.$router.push('/analytics/reportsV2/offers');
    } else {
      let notFound = true;
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.$route.params.type === this.tabs[i].name.toLowerCase()) {
          this.activeTab = i;
          notFound = false;
          break;
        }
      }
      if (notFound) {
        this.$router.push('/404')
      }
    }
  },
  watch: {
    onlyAggregatedStats: async function () {
      await store.dispatch('reports/saveOnlyAggregatedStats', {
        onlyAggregatedStats: !this.onlyAggregatedStats
      })
    },
    isShowBlacklisted: function () {
      console.log('grand', this.isShowBlacklisted)
    },
    activeTab: function () {
      document.title = `Reports-${this.$route.params.type}`;
      this.setCurrentFields();
    },
    getAppliedSettings() {
      const settingsTabs = this.getAppliedSettings && this.getAppliedSettings.settings && this.getAppliedSettings.settings.tabs
          ? this.getAppliedSettings.settings.tabs
          : [];
      if (!settingsTabs.length) return;
      this.tabs = this.initialTabs.filter(tab => settingsTabs.includes(tab.name));

    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('settings', ['getAppliedSettings']),
  },
  methods: {
    async loadSettings() {
      await this.$store.dispatch("settings/getSettingsStore");
      const settingsId = await this.$store.dispatch("settings/getManagerSettingsIdStore");

      if (settingsId) {
        await this.$store.dispatch("settings/setCurrentSettingsStore", settingsId);
        await this.$store.dispatch("settings/setAppliedSettingsStore", settingsId);
      }
      this.loading = false;
    },
    tabChange(id) {
      if (!this.tabs[id]) return;
      this.$router.push(`/analytics/reportsV2/${this.tabs[id].name.toLowerCase()}`);
      store.dispatch('settings/hideGraphStore')
    },
    exportReports() {
      this.isExportSettingsDialogOpen = !this.isExportSettingsDialogOpen;
    },
    showGraph() {
      this.isGraphVisible = !this.isGraphVisible;
      this.$store.dispatch('settings/toggleGraphStore');
    },
    setCurrentFields() {
      const currentTab = this.tabs[this.activeTab];
      this.currentFields.length = 0;
      if (currentTab) {
        try {
          const selectedFileds = JSON.parse(localStorage.getItem(`fields-${currentTab.name.toLowerCase()}`));
          this.currentFields = selectedFileds && Array.isArray(selectedFileds)
              ? [...this.commonHeaders].filter(ch => selectedFileds.includes(ch))
              : [...this.commonHeaders];
          this.currentFields.unshift(currentTab.name.toLowerCase());
        } catch (e) {
          console.log(e.message)
        }
      }
    },
    manageSettings() {
      this.isShowSettings = !this.isShowSettings;
    },
  }
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/styles.sass'
.none-tab
  pointer-events: none
  opacity: 0.3
.title_page
  position: relative
  padding-top: 10px
  display: inline
.export-btn
  display: inline
  margin-left: 3%
.report_section
  min-width: 250px
  width: 25%
.reports_tabs.theme--light.v-tabs>.v-tabs-bar
  background-color: var(--v-tertiary-base)
  border-radius: 4px
  width: fit-content
  margin-left: 120px
  margin-bottom: 10px
  padding: 5px
.v-tabs-slider-wrapper
  display: none
.reports_tabs.theme--light.v-tabs>.v-tabs-bar .v-tab
  text-transform: capitalize
  font-weight: 600
  font-size: 16px
  color: var(--v-accent-darken2) !important
  position: relative
  padding: 0 30px
  &:last-child
    &::after
      display: none
  &::after
    position: absolute
    top: 2px
    right: 0px
    display: block
    content: ''
    width: 1px
    height: 32px
    background-color: var(--v-accent-darken2)
.reports_tabs.theme--light.v-tabs>.v-tabs-bar .v-tab--active
  color: #fff !important
  background-color: var(--v-primary-base) !important
  border-radius: 4px
.v-tab--active.v-tab:not(:focus):before
  background-color: var(--v-primary-base)

</style>
